import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

@Component
export default class CommonMixin extends Vue {
  // WIP Will migrate loaders into Common Mixin
  @Action('resetPage')
  resetPage!: () => void;

  @Getter('isLoading')
  isLoading!: (id: string | number | null) => boolean;

  @Getter('isInitialLoaded')
  isInitialLoaded!: (key: string | null) => boolean;
}
